export var MediaLabelSize;
(function (MediaLabelSize) {
    MediaLabelSize["large"] = "large";
    MediaLabelSize["small"] = "small";
})(MediaLabelSize || (MediaLabelSize = {}));
//# sourceMappingURL=types.js.map